import React, { useState } from "react";
import { motion } from "framer-motion";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPaperPlane, faCheck } from "@fortawesome/free-solid-svg-icons";
import { sendMessage } from "../utils/firebase";
import "./styles/ContactSection.css";

const fadeUp = {
	hidden: { opacity: 0, y: 20 },
	visible: { opacity: 1, y: 0, transition: { duration: 0.5 } },
};

const ContactSection = () => {
	const [form, setForm] = useState({ name: "", email: "", message: "" });
	const [status, setStatus] = useState("idle");

	const handleChange = (e) => {
		setForm({ ...form, [e.target.name]: e.target.value });
	};

	const handleSubmit = async (e) => {
		e.preventDefault();
		setStatus("sending");

		const { error } = await sendMessage(form);

		if (error) {
			setStatus("error");
		} else {
			setStatus("sent");
			setForm({ name: "", email: "", message: "" });
		}
	};

	return (
		<section className="cta">
			<div className="content-wrapper">
				<motion.div
					className="cta__layout"
					variants={fadeUp}
					initial="hidden"
					whileInView="visible"
					viewport={{ once: true }}
				>
					<div className="cta__left">
						<span className="cta__label">Say hello</span>
						<h1 className="cta__title">Got something<br />in mind?</h1>
						<p className="cta__desc">
							If you want to talk about work, a project, or anything really — don't hesitate to reach out. Thanks.
						</p>
					</div>

					{status === "sent" ? (
						<div className="cta__success">
							<FontAwesomeIcon icon={faCheck} className="cta__success-icon" />
							<h3 className="cta__success-title">Got it.</h3>
							<p className="cta__success-text">I'll get back to you.</p>
						</div>
					) : (
						<form onSubmit={handleSubmit} className="cta__form">
							<div className="cta__field">
								<label htmlFor="name">Name</label>
								<input
									type="text"
									id="name"
									name="name"
									placeholder="Your name"
									value={form.name}
									onChange={handleChange}
									required
									disabled={status === "sending"}
								/>
							</div>
							<div className="cta__field">
								<label htmlFor="email">Email</label>
								<input
									type="email"
									id="email"
									name="email"
									placeholder="your@email.com"
									value={form.email}
									onChange={handleChange}
									required
									disabled={status === "sending"}
								/>
							</div>
							<div className="cta__field">
								<label htmlFor="message">Message</label>
								<textarea
									id="message"
									name="message"
									placeholder="Tell me about your project..."
									rows="5"
									value={form.message}
									onChange={handleChange}
									required
									disabled={status === "sending"}
								/>
							</div>
							<button
								type="submit"
								className="cta__btn"
								disabled={status === "sending"}
							>
								<FontAwesomeIcon icon={faPaperPlane} />
								{status === "sending" ? "Sending..." : "Send Message"}
							</button>
							{status === "error" && (
								<p className="cta__error">Something went wrong. Try again.</p>
							)}
						</form>
					)}
				</motion.div>
			</div>
		</section>
	);
};

export default ContactSection;
